import React from "react";

export default function GetJobType({ jobtypesList, depIndex }) {
  if (!jobtypesList || jobtypesList.length === 0) {
    return "סוג לא מוגדרת";
  }
  const searchType = jobtypesList.find((dep) => dep.id == depIndex);
  return searchType ? searchType.title : "סוג לא מוגדרת";
}
